exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error-container .icon-container[data-v-3d0e2168] {\n  font-size: 10rem;\n  color: #fa6657;\n}\n.error-container i[data-v-3d0e2168] {\n  display: flex;\n  justify-content: center;\n}\n.notify-text[data-v-3d0e2168] {\n  display: flex;\n  justify-content: center;\n  padding: 0 20% 0;\n}", ""]);

// exports
